module.exports = __webpack_public_path__ + "static/media/psyc_today_png.6592fe8d.png";